module.exports = __webpack_public_path__ + "img/Proliferation-BRME_GSE179572.bd493698.png";